import { createContext } from 'react';

const MapContext = /*#__PURE__*/createContext({
  map: null,
  setMap: () => {
    // eslint-disable-next-line no-console
    console.error('MapContext::setMap called without a provider');
  }
});

export { MapContext as default };
//# sourceMappingURL=MapContext.js.map
